import React, { useState, useEffect,useContext } from "react";
import { Modal, Input, Table, Typography, Button, Alert, Switch, notification } from "antd";
import dayjs from "dayjs";
import mainContext from "../context/MainContext/mainContext";
const { Title, Text } = Typography;

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const CreditNote = ({ visible, onClose, invoiceData, onGenerate }) => {

  console.log("invoiceData for credit note", invoiceData);
  const { generateCreditNoteGov, cancelBillingInvoice } = useContext(mainContext);
  const [amount, setAmount] = useState("");
  const [isFullBill, setIsFullBill] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const inventories = invoiceData?.infoForCN || [];
  const invSummery = invoiceData?.infoForCNSummery || [];
  const [updatedInventories, setUpdatedInventories] = useState(inventories);
  const [rowAmounts, setRowAmounts] = useState([]);
  // console.log("inventoriesddddhbyvvcytcytc",inventories)
  // Calculate total of all inventories
  const totalInventoryAmount = inventories.reduce(
    (sum, inv) => sum + (parseFloat(inv.amount) || 0),
    0
  );

  const printingCharge = invoiceData?.infoForCNSummery?.printingCharge || 0;
  const mountingCharge = invoiceData?.infoForCNSummery?.mountingCharge || 0;
  const totalCreditNoteAmount = totalInventoryAmount + printingCharge + mountingCharge;

  useEffect(() => {
    setUpdatedInventories(inventories);
  }, [inventories]);

  useEffect(() => {
    if (isFullBill) {
      // Set main amount to total inventory amount
      setAmount(totalInventoryAmount.toString());
      // Set each row's credit note amount to match its inventory amount
      setRowAmounts(inventories.map(inv => inv.amount?.toString() || ""));
      
      // Update updatedInventories with creditNoteAmount
      const newUpdatedInventories = inventories.map(inv => ({
        ...inv,
        creditNoteAmount: parseFloat(inv.amount) || 0
      }));
      setUpdatedInventories(newUpdatedInventories);
      console.log("updatedInventories", newUpdatedInventories);
    } else {
      // Reset to initial state when toggle is off
      setAmount("");
      setRowAmounts(Array(inventories.length).fill(""));
      setUpdatedInventories(inventories);
    }
  }, [isFullBill, inventories, totalInventoryAmount]);

  // Calculate remaining amount to allocate
  const totalAllocated = rowAmounts.reduce(
    (sum, val) => sum + (parseFloat(val) || 0),
    0
  );
  const remaining = (parseFloat(amount) || 0) - totalAllocated;

  const handleRowAmountChange = (idx, value) => {
    if (!isFullBill) {  // Only allow changes if not in full bill mode
      const updated = [...rowAmounts];
      updated[idx] = value;
      setRowAmounts(updated);
      
      // Update the creditNoteAmount in inventories
      const newUpdatedInventories = [...updatedInventories];
      newUpdatedInventories[idx] = {
        ...newUpdatedInventories[idx],
        creditNoteAmount: parseFloat(value) || 0
      };
      setUpdatedInventories(newUpdatedInventories);
      console.log("updatedInventories", newUpdatedInventories);
    }
  };

  const columns = [
    {
      title: "CodeNo",
      dataIndex: "CodeNo",
      key: "CodeNo",
      width: 100,
    },
    {
      title: "Location",
      dataIndex: "locationName",
      key: "locationName",
      ellipsis: true,
      width: 200,
    },
    {
      title: "Size",
      key: "size",
      width: 80,
      render: (_, record) => `${record.width} x ${record.height}`,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 120,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : ""),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      width: 120,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : ""),
    },
    // {
    //   title: "Amount",
    //   dataIndex: "amount",
    //   key: "amount",
    //   align: "right",
    //   width: 100,
    //   render: (amt) =>
    //     amt?.toLocaleString("en-IN", { minimumFractionDigits: 0 }),
    // },
    {
      title: "Credit Note Amount",
      key: "creditNoteAmount",
      width: 140,
      render: (_, record) => (
        <span style={{ textAlign: "right", display: "block", backgroundColor: "#f26161", borderRadius: "3px", padding: "3px"}}>
          {record.amount?.toLocaleString("en-IN", { minimumFractionDigits: 0 })}
        </span>
      ),
    },
  ];

  const handleGenerate = async (datareq) => {
    try {
      const creditNoteData = {
        // Static values for now
     

        IRN: invoiceData?.IRN || null,
        AckNumber: invoiceData?.AckNo || null,
        AckDate: invoiceData?.AckDate || null,
        SignedInvoice: invoiceData?.SignedInvoice || null,
        SignedQrCode: invoiceData?.SignedQRCode || null,
        CnNumber: invoiceData?.cnNumber || null,
        ...datareq, 
        printingCharge: printingCharge,
        mountingCharge: mountingCharge,
        totalAmount: totalCreditNoteAmount,
        invoiceId: invoiceData.invoiceId,
        inventoryAgainst: inventories.map((inv) => ({
          invId: inv._id,
          amount: parseFloat(inv.amount),
          specialRate: inv.amount,
          startDate: inv.startDate,
          endDate: inv.endDate,
        })),
        gstNumber:invoiceData.gstNumber
      };
      console.log("creditNoteData", invoiceData);
      const response = await fetch(`${apiBaseUrl}/inventoryManagement/createCreditNote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(creditNoteData)
      });

      const data = await response.json();

      if (data.success) {
        if (data?.isCNGeneratedAgainstFullInvoice === true) {
          const invIdToCancel = data?.invoiceId;
          const cancelRemark = data?.remark || "";
          const cancelled = await cancelBillingInvoice?.(invIdToCancel, cancelRemark);
          if (cancelled === false) {
            return;
          }
        }
        notification.success({
          message: 'Credit Note Generated',
          description: data.message
        });
        onClose();
        onGenerate(amount);
      } else {
        notification.error({
          message: 'Failed to generate Credit Note',
          description: data.message
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.message || 'Failed to generate credit note'
      });
    }
  };

  return (
    <Modal
      title={<Title level={4}>Credit Note</Title>}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="generate"
          type="primary"
          loading={isGenerating}
          disabled={isGenerating}
          onClick={async () => {
            setIsGenerating(true);
            try {
              const datareq = await generateCreditNoteGov(
                invoiceData?.gstNumber,
                invSummery,
                invoiceData?.HSN,
                invoiceData?.cnNumber,
                invoiceData,
              );
              handleGenerate(datareq);
            } finally {
              setIsGenerating(false);
            }
          }}
        >
          Generate Credit Note (On gov portal)
        </Button>,
      ]}
      width={900}
    >
      {invoiceData?.cnNumber && (
        <div style={{ marginBottom: 16 }}>
          <Text strong>Credit Note Number: </Text>
          <Text>{invoiceData.cnNumber}</Text>
        </div>
      )}
      {/* <div style={{ marginBottom: 16 }}>
        <label>Amount to generate for credit note:</label>
        <Input
          type="number"
          value={amount}
          onChange={(e) => !isFullBill && setAmount(e.target.value)}
          placeholder="Enter credit note amount"
          min={0}
          disabled={isFullBill}
        />
      </div> */}
      {amount != 0 && (
        <Alert
          type={remaining === 0 ? "success" : remaining > 0 ? "info" : "error"}
          showIcon
          style={{ marginBottom: 16 }}
          message={
            remaining === 0
              ? "All amount settled."
              : remaining > 0
              ? `₹${remaining.toLocaleString("en-IN", {
                  minimumFractionDigits: 0,
                })} is pending settlement.`
              : `Over-allocated by ₹${Math.abs(remaining).toLocaleString(
                  "en-IN",
                  { minimumFractionDigits: 0 }
                )}`
          }
        />
      )}
      <Table
        columns={columns}
        dataSource={inventories}
        rowKey={(_, idx) => idx}
        pagination={false}
        bordered
        size="small"
        style={{ marginTop: 16 }}
        scroll={{ x: 790 }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginTop: 16, marginBottom: 16, gap: '4px' }}>
        <Text>Printing Charge: ₹{printingCharge.toLocaleString("en-IN", { minimumFractionDigits: 0 })}</Text>
        <Text>Mounting Charge: ₹{mountingCharge.toLocaleString("en-IN", { minimumFractionDigits: 0 })}</Text>
        <Text strong>Total Credit Note Amount: ₹{totalCreditNoteAmount.toLocaleString("en-IN", { minimumFractionDigits: 0 })}</Text>
      </div>
    </Modal>
  );
};

export default CreditNote;
